import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { CustomerInfo_$reflection } from "./Shared/ApiDataTypes.js";
import { bind, unwrap, map, defaultArg, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "./Promises.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { tail, head, isEmpty, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { union_type, string_type, obj_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, int32ToString, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { toString as toString_1, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { hierarchyContext } from "./CompanyHierarchyContext.js";
import { useResponsive } from "./Utils.js";
import { tryFind, tryPick } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { RouterModule_encodeParts, RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Route_$007CGuid$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { errorBanner } from "./ViewHelpers.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Tab, Tabs, Typography, Link, Breadcrumbs } from "@mui/material";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { View } from "./Customer/Dashboard/Dashboard.js";
import { Activities } from "./ActivityView.js";
import { Target } from "./Activities/Services.js";
import { View as View_1, Target as Target_1 } from "./Economy.js";
import { GasReport_View_Z6C265741 } from "./GasReport.js";
import { ListTarget, List } from "./Ticket/CustomerTicketList.js";
import { List as List_1 } from "./Customer/Orders.js";
import { Documents_View_Z721C83C5 } from "./DocumentView.js";
import { Provider } from "./Documents/DocumentContext.js";
import { View as View_2 } from "./Customer/CustomerDocuments.js";
import { Customer_Overview_Z5E02542 } from "./Customer/CustomerOverview.js";

function updateCustomer(callback) {
    return (arg_1) => {
        let properties_2;
        let pr_1;
        const data = some(Auto_generateBoxedEncoder_437914C6(CustomerInfo_$reflection(), undefined, undefined, undefined)(arg_1));
        const decoder = Auto_generateBoxedDecoder_Z6670B51(CustomerInfo_$reflection(), undefined, undefined);
        const data_1 = data;
        const caseStrategy_3 = undefined;
        const extra_3 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/customer/edit", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(CustomerInfo_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then(callback);
    };
}

class SubView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Overview", "Dashboard", "ActivityPlan", "Economy", "GasReport", "Tickets", "Orders", "Document", "Documents"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "dashboard" : ((this$.tag === 2) ? "activity-plan" : ((this$.tag === 3) ? "economy" : ((this$.tag === 4) ? "gas-report" : ((this$.tag === 5) ? "tickets" : ((this$.tag === 6) ? "orders" : ((this$.tag === 8) ? "documents" : ((this$.tag === 7) ? "documents" : "overview")))))));
    }
}

function SubView_$reflection() {
    return union_type("Kundeweb.CustomerView.SubView", [], SubView, () => [[], [], [], [], [], [], [], [["Item", string_type]], []]);
}

export function Customer(customerInputProps) {
    const customerId = customerInputProps.customerId;
    const groupId = customerInputProps.groupId;
    const path = customerInputProps.path;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const responsive = useResponsive(undefined);
    let patternInput;
    const matchValue = ctx.Session;
    if (matchValue == null) {
        patternInput = [false, false];
    }
    else {
        const s = matchValue;
        patternInput = [s.IsSuperAdmin ? true : s.IsAdmin, s.TicketAccess];
    }
    const patternInput_1 = reactApi.useState(undefined);
    const customerInfoOpt = bind((group_1) => tryPick((customer) => {
        if (customer.Id === customerId) {
            return [group_1, customer];
        }
        else {
            return undefined;
        }
    }, group_1.Customers), tryFind((group) => (group.Id === groupId), hierarchy.Groups));
    let currentView;
    let matchResult, docId;
    if (!isEmpty(path)) {
        switch (head(path)) {
            case "overview": {
                if (isEmpty(tail(path))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 9;
                }
                break;
            }
            case "dashboard": {
                matchResult = 1;
                break;
            }
            case "economy": {
                matchResult = 2;
                break;
            }
            case "gas-report": {
                if (isEmpty(tail(path))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 9;
                }
                break;
            }
            case "activity-plan": {
                if (isEmpty(tail(path))) {
                    matchResult = 4;
                }
                else {
                    matchResult = 9;
                }
                break;
            }
            case "tickets": {
                if (isEmpty(tail(path))) {
                    matchResult = 5;
                }
                else {
                    matchResult = 9;
                }
                break;
            }
            case "orders": {
                if (isEmpty(tail(path))) {
                    matchResult = 6;
                }
                else {
                    matchResult = 9;
                }
                break;
            }
            case "documents": {
                if (!isEmpty(tail(path))) {
                    const activePatternResult = Route_$007CGuid$007C_$007C(head(tail(path)));
                    if (activePatternResult != null) {
                        if (isEmpty(tail(tail(path)))) {
                            matchResult = 8;
                            docId = activePatternResult;
                        }
                        else {
                            matchResult = 9;
                        }
                    }
                    else {
                        matchResult = 9;
                    }
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            default:
                matchResult = 9;
        }
    }
    else {
        matchResult = 9;
    }
    switch (matchResult) {
        case 0: {
            currentView = (new SubView(0, []));
            break;
        }
        case 1: {
            if (customerInfoOpt != null) {
                if (!customerInfoOpt[1].EnableExtra) {
                    const segment3 = toString_1(new SubView(0, []));
                    RouterModule_nav(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerId), segment3]), 1, 1);
                    currentView = (new SubView(0, []));
                }
                else {
                    currentView = (new SubView(1, []));
                }
            }
            else {
                currentView = (new SubView(0, []));
            }
            break;
        }
        case 2: {
            currentView = (new SubView(3, []));
            break;
        }
        case 3: {
            currentView = (new SubView(4, []));
            break;
        }
        case 4: {
            currentView = (new SubView(2, []));
            break;
        }
        case 5: {
            currentView = (new SubView(5, []));
            break;
        }
        case 6: {
            currentView = (new SubView(6, []));
            break;
        }
        case 7: {
            currentView = (new SubView(8, []));
            break;
        }
        case 8: {
            currentView = (new SubView(7, [docId]));
            break;
        }
        default:
            currentView = (new SubView(0, []));
    }
    const xs_7 = toList(delay(() => append(singleton(errorBanner(patternInput_1[0], () => {
        patternInput_1[1](undefined);
    })), delay(() => {
        let elems_5, elements, elems_2, elems_1, elems_4;
        const matchValue_1 = customerInfoOpt;
        if (matchValue_1 != null) {
            const group_2 = matchValue_1[0];
            const customerInfo = matchValue_1[1];
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                overflowX: "hidden",
                rowGap: 10 + "px",
                padding: ((((((0 + "px") + " ") + (0 + "px")) + " ") + (10 + "px")) + " ") + (10 + "px"),
                width: 100 + "%",
            }], (elems_5 = [MuiHelpers_createElement(Breadcrumbs, [(elements = [MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId)]), 1)], ["children", group_2.Name]]), MuiHelpers_createElement(Link, [["className", "selected"], ["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerInfo.Id)]), 1)], ["classes.root", "hover-link"], ["children", customerInfo.Name]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                width: 100 + "%",
            }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                flexGrow: 1,
                minWidth: 100 + "px",
            }], (elems_1 = [MuiHelpers_createElement(Typography, [["title", customerInfo.Name], ["variant", "h1"], ["noWrap", true], ["children", customerInfo.Name]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
            }], (elems_4 = [MuiHelpers_createElement(Tabs, toList(delay(() => append((responsive !== "wideScreen") ? singleton(["variant", "scrollable"]) : empty_1(), delay(() => append(singleton(["indicatorColor", "primary"]), delay(() => append(singleton(["textColor", "primary"]), delay(() => append(singleton(["value", toString_1(currentView)]), delay(() => append(singleton(["onChange", (_arg_1, v) => {
                const str = v;
                console.debug("Customer tab change", str);
                RouterModule_nav(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerId), str]), 1, 1);
            }]), delay(() => {
                let elements_1;
                return singleton((elements_1 = toList(delay(() => append(singleton(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Overview")], ["value", toString_1(new SubView(0, []))]])), delay(() => append(customerInfo.EnableExtra ? singleton(MuiHelpers_createElement(Tab, [["label", "Dashboard"], ["value", toString_1(new SubView(1, []))]])) : empty_1(), delay(() => append(customerInfo.EnableServices ? singleton(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.ActivityPlan")], ["value", toString_1(new SubView(2, []))]])) : empty_1(), delay(() => append(singleton(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Economy")], ["value", toString_1(new SubView(3, []))]])), delay(() => append(singleton(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.GasReport")], ["value", toString_1(new SubView(4, []))]])), delay(() => {
                    let matchValue_2, s_1;
                    return append((matchValue_2 = ctx.Session, (matchValue_2 != null) ? ((s_1 = matchValue_2, ((!s_1.TicketAccess && !s_1.IsAdmin) && !s_1.IsPtg) ? singleton(defaultOf()) : singleton(MuiHelpers_createElement(Tab, [["style", {}], ["label", ctx.Locale.t("CustomerSite.Tabs.Tickets")], ["value", toString_1(new SubView(5, []))]])))) : singleton(defaultOf())), delay(() => {
                        let matchValue_3, s_2;
                        return append((matchValue_3 = ctx.Session, (matchValue_3 != null) ? ((s_2 = matchValue_3, ((!s_2.TicketAccess && !s_2.IsAdmin) && !s_2.IsPtg) ? singleton(defaultOf()) : singleton(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Orders")], ["value", toString_1(new SubView(6, []))]])))) : singleton(defaultOf())), delay(() => singleton(MuiHelpers_createElement(Tab, [["label", ctx.Locale.t("CustomerSite.Tabs.Documents")], ["value", toString_1(new SubView(8, []))]]))));
                    }));
                })))))))))))), ["children", reactApi.Children.toArray(Array.from(elements_1))]));
            })))))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                let elems_6, target_1, $key25C142D7, $key49B57437, $key7B954FA3;
                return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container", "main-tab-container-outer"])], (elems_6 = [createElement("div", {
                    className: join(" ", ["main-tab-container-inner"]),
                    children: (currentView.tag === 1) ? createElement(View, {
                        groupId: groupId,
                        customerId: customerId,
                    }) : ((currentView.tag === 2) ? createElement(Activities, {
                        target: new Target(1, [groupId, customerId, customerInfo]),
                    }) : ((currentView.tag === 3) ? ((target_1 = (new Target_1(1, [customerId])), ($key25C142D7 = toString_1(target_1), createElement(View_1, {
                        key: $key25C142D7,
                        $key: $key25C142D7,
                        target: target_1,
                    })))) : ((currentView.tag === 4) ? createElement(GasReport_View_Z6C265741, {
                        groupId: groupId,
                        customerId: customerId,
                    }) : ((currentView.tag === 5) ? createElement(List, {
                        target: new ListTarget(1, [groupId, customerId]),
                    }) : ((currentView.tag === 6) ? createElement(List_1, customerInfo) : ((currentView.tag === 7) ? createElement(Documents_View_Z721C83C5, {
                        documentId: currentView.fields[0],
                    }) : ((currentView.tag === 8) ? (($key49B57437 = (`customer-${customerId}-documents-provider`), createElement(Provider, {
                        key: $key49B57437,
                        $key: $key49B57437,
                        children: [($key7B954FA3 = (`customer-${customerId}-documents-view`), createElement(View_2, {
                            key: $key7B954FA3,
                            $key: $key7B954FA3,
                            groupId: groupId,
                            customerId: customerId,
                        }))],
                    }))) : createElement(Customer_Overview_Z5E02542, {
                        groupId: groupId,
                        customer: customerInfo,
                    })))))))),
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
            }));
        }
        else {
            return hierarchy.GroupsFetched ? singleton(createElement("p", {
                children: ["Ingen tilgang ..."],
            })) : singleton(createElement("p", {
                children: ["Laster kunde ..."],
            }));
        }
    }))));
    return react.createElement(react.Fragment, {}, ...xs_7);
}

